<header>
  <div id="membership-form">
    <div class="mbsc-form-group">
      <div class="mbsc-form-group-title">Tu membresía</div>
      <label>
        Monto: 
        <input mbsc-input type="text" disabled="true" value="{totalAmount}" />
      </label>
      <label>
        Forma de pago: 
        <input mbsc-input type="text" disabled="true" value="{paymentType}" />
      </label>
      <label>
        Valida hasta: 
        <input mbsc-input type="text" disabled="true" value="{validTo}" />
      </label>
      {#if (!invalidSubscription) && (paymentType !== 'Free')}
      <button mbsc-button on:click={cancelSubscription} disabled={invalidSubscription}>Cancelar mi subscripción</button><br>
      <small>Al cancelar tu subscripción seguirás teniendo acceso total hasta la fecha de validez de tu membresía actual.<br>A partir de ahí, podrás seguir disfrutando de las sesiones gratis que D-NS Studio tiene para tí.</small>
      {:else}
      <small>Tu subscripción no está activa, pero aún puedes seguir disfrutando de las sesiones gratis que D-NS Studio tiene para tí.</small>
      {/if}
    </div>
  </div>
</header>

<script>
  import { onMount, afterUpdate } from 'svelte';
  import { AWSAuth, Navigation, Stripe } from '@Services';

  const DEBUG = document.location.protocol === 'http:' ? true : false;

  let totalAmount = "$0.00 MXN";
  let userId = null;
  let paymentType = "Free";
  let validTo = "-";
  let validToDate = null;
  let curUser = null;
  let invalidSubscription = false;

  let cancelSubscription = () => {
    if (curUser && curUser.attributes && (invalidSubscription === false) && (validToDate >= new Date()) && (paymentType === 'STRIPE')) {
      mobiscroll.prompt({
        title: '¿Deseas cancelar tu subscripción?',
        message: 'Muchas gracias por confiar en nosotros durante este tiempo. <br>Si deseas cancelar tu subscripción por favor introduce la palabra <span style="color: red">CANCELAR</span> en la caja de abajo.',
        placeholder: 'Confirma tu cancelación',
        inputType: 'text',
        callback: function (value) {
          if (value === 'CANCELAR') {
            if ('custom:flags' in curUser.attributes) {
            }else{
              // set cancel equals to 1
              AWSAuth.updateMember(curUser, {
                'custom:flags': JSON.stringify({
                  'C': 1,
                }),
              });
            }
            Stripe.cancelSubscription({
              stripeCustomer: userId,
              userEmail: curUser.attributes.email,
            }).then(response => {
              mobiscroll.toast({
                message: 'Tu subscripción ha sido cancelada correctamente.'
              });
            }).catch(error => {
              console.error(error);
              mobiscroll.toast({
                message: 'Gracias, en breve recibirás tu confirmación de cancelación.'
              });
            });
          }else{
            window.location.reload();
          }
        }
      });
    }
  };

  afterUpdate(() => {});

  onMount(async () =>{
    AWSAuth.getUser().then(response => {
      if (typeof response === 'string' && response === 'not authenticated') {
        Navigation.goTo('home');
      }else if (response && response.attributes) {
        curUser = response;
        const currentMembershipInfo = JSON.parse(response.attributes["custom:txInfo"]);
        if (currentMembershipInfo.tx !== null) {
          userId = currentMembershipInfo.tx.split('|')[0];
          totalAmount = "$" + currentMembershipInfo.tx.split('|')[1] + " MXN";
          paymentType = currentMembershipInfo.tx.split('|')[2];
          validToDate = new Date(currentMembershipInfo.v);
        }else{
          totalAmount = "$0.00 MXN";
          paymentType = "Free";
          const expireDate = new Date(currentMembershipInfo.v);
          if (expireDate >= Date.now()) {
            invalidSubscription = false;
          }
          const ye = new Intl.DateTimeFormat('es', { year: 'numeric' }).format(expireDate);
          const mo = new Intl.DateTimeFormat('es', { month: 'long' }).format(expireDate);
          const da = new Intl.DateTimeFormat('es', { day: 'numeric' }).format(expireDate);
          validTo = da + " de " + mo + " del " + ye;
        }
        if (paymentType !== 'Free') {
          const expireDate = new Date(currentMembershipInfo.v);
          if (expireDate >= Date.now()) {
            invalidSubscription = false;
          }
          // check if subscription was already cancelled.
          if ("custom:flags" in response.attributes) {
            const memberFlags = JSON.parse(response.attributes['custom:flags']);
            if (('C' in memberFlags) && (memberFlags['C'] === 1)) {
              invalidSubscription = true;
            }
          }
          const ye = new Intl.DateTimeFormat('es', { year: 'numeric' }).format(expireDate);
          const mo = new Intl.DateTimeFormat('es', { month: 'long' }).format(expireDate);
          const da = new Intl.DateTimeFormat('es', { day: 'numeric' }).format(expireDate);
          validTo = da + " de " + mo + " del " + ye;
        }
      }else{
        console.error('Invalid member attributes.');
        Navigation.goTo('home');
      }
    });
  });
</script>
